import { Observable, map } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MfaGateway } from './mfa-gateway'
import { verifyAuthTokenModel } from '../../auth/verify-Auth-Token'

@Injectable()
export class NetworkMfaGateway extends MfaGateway {
   

    constructor(private http: HttpClient) {
        super()
    }

    sendAuthCode(): Observable<any> {
     return  this.http.get<any>('../api/sendauthcode')
    }
    verifyAuthenticationCode(mfaRequestModel: verifyAuthTokenModel): Observable<any> {
        return this.http.post<any>('../api/verifyauthcode', JSON.stringify(mfaRequestModel))
    }
}
